import {
  createImageUrlAutoFormField,
  type SpecsAutoFormFieldMetadataMap,
} from "../autoFormMetadata";
import { ObservableModelNode } from "../observable";
import {
  cloneValue,
  expectObject,
  readOptionalNumber,
  readString,
  splitKnown,
} from "../utils";

export class ProductVersionCompanyLogoLabelModel extends ObservableModelNode {
  static autoFormFields: SpecsAutoFormFieldMetadataMap = {
    descriptionKey: { label: "Description Key", fieldType: "text" },
    x1: { label: "X1", fieldType: "number", allowNull: true },
    x2: { label: "X2", fieldType: "number", allowNull: true },
    y: { label: "Y", fieldType: "number", allowNull: true },
    w: { label: "W", fieldType: "number", allowNull: true },
    h: { label: "H", fieldType: "number", allowNull: true },
    defaultLabelInstructionUrl: createImageUrlAutoFormField({
      label: "Default Label Instruction URL",
    }),
    customLabelInstructionUrl: createImageUrlAutoFormField({
      label: "Custom Label Instruction URL",
    }),
    customLabelInstructionMaskUrl: createImageUrlAutoFormField({
      label: "Custom Label Instruction Mask URL",
    }),
    extra: { label: "Extra JSON", fieldType: "json", minRows: 4 },
  };

  descriptionKey!: string;
  x1!: number | null;
  x2!: number | null;
  y!: number | null;
  w!: number | null;
  h!: number | null;
  defaultLabelInstructionUrl!: string;
  customLabelInstructionUrl!: string;
  customLabelInstructionMaskUrl!: string;
  extra!: Record<string, unknown>;

  constructor() {
    super();
    this.defineObservableValue("descriptionKey", "");
    this.defineObservableValue("x1", null);
    this.defineObservableValue("x2", null);
    this.defineObservableValue("y", null);
    this.defineObservableValue("w", null);
    this.defineObservableValue("h", null);
    this.defineObservableValue("defaultLabelInstructionUrl", "");
    this.defineObservableValue("customLabelInstructionUrl", "");
    this.defineObservableValue("customLabelInstructionMaskUrl", "");
    this.defineObservableValue("extra", {});
  }

  restore(snapshot: unknown) {
    const source = expectObject(snapshot, "product company logo label");
    this.descriptionKey = readString(source, "descriptionKey");
    this.x1 = readOptionalNumber(source, "x1");
    this.x2 = readOptionalNumber(source, "x2");
    this.y = readOptionalNumber(source, "y");
    this.w = readOptionalNumber(source, "w");
    this.h = readOptionalNumber(source, "h");
    this.defaultLabelInstructionUrl = readString(
      source,
      "defaultLabelInstructionUrl"
    );
    this.customLabelInstructionUrl = readString(
      source,
      "customLabelInstructionUrl"
    );
    this.customLabelInstructionMaskUrl = readString(
      source,
      "customLabelInstructionMaskUrl"
    );
    this.extra = splitKnown(source, [
      "descriptionKey",
      "x1",
      "x2",
      "y",
      "w",
      "h",
      "defaultLabelInstructionUrl",
      "customLabelInstructionUrl",
      "customLabelInstructionMaskUrl",
    ]);
    return this;
  }

  save() {
    return {
      ...cloneValue(this.extra),
      ...(this.descriptionKey ? { descriptionKey: this.descriptionKey } : {}),
      ...(this.x1 === null ? {} : { x1: this.x1 }),
      ...(this.x2 === null ? {} : { x2: this.x2 }),
      ...(this.y === null ? {} : { y: this.y }),
      ...(this.w === null ? {} : { w: this.w }),
      ...(this.h === null ? {} : { h: this.h }),
      ...(this.defaultLabelInstructionUrl
        ? { defaultLabelInstructionUrl: this.defaultLabelInstructionUrl }
        : {}),
      ...(this.customLabelInstructionUrl
        ? { customLabelInstructionUrl: this.customLabelInstructionUrl }
        : {}),
      ...(this.customLabelInstructionMaskUrl
        ? { customLabelInstructionMaskUrl: this.customLabelInstructionMaskUrl }
        : {}),
    };
  }
}
